import {
	GET_ALL_PRODUCTS,
	SAVE_PRODUCT,
	DELETE_PRODUCT
} from '../../Actions/Admin/ManageProductActions';

const initialState = {
	products: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ALL_PRODUCTS:
			return {
				...state,
				loading: true,
				products: action.payload
			};
		
		case SAVE_PRODUCT:
			return {
				...state,
				products: action.payload
			};
		case DELETE_PRODUCT:
			return {
				...state,
				products: action.payload
			};
		default:
			return state;
	}
};
